<template>
  <div class="topic_switch">
    <div class="title">
      <a href="javascript:;" :class="[title.hendler?'topic_type active':'topic_type']" @click="switchTab(title)"
         v-for="title in titleList">{{title.name}}<i></i>
      </a>
    </div>
    <div class="con">
      <transition name="my-fade" tag="div" appear>
        <div class="mask" @click="hide" v-show="titleList[0].hendler||titleList[1].hendler"></div>
      </transition>
      <!-- 题型: -->
      <transition name="my-slide1" tag="div">
        <div class="tixing" v-show="titleList[0].hendler" :style="`height:${Math.ceil(tixingList.length/2) * 2.45 - 0.1}rem`">
          <ul class="clearfix">
            <li @click="switchTixing(tixing)" v-for="tixing in tixingList">
              {{tixing.name}}<i :class="{'active':tixing.hendler}"></i>
            </li>
          </ul>
        </div>
      </transition>
      <!-- 范围: -->
      <transition name="my-slide2" tag="div">
        <div class="fanwei" v-show="titleList[1].hendler"  :style="`height:${Math.ceil(fanweiList.length/2) * 2.45 - 0.1}rem`">
          <ul class="clearfix">
            <li @click="switchFanwei(fanwei)" v-for="fanwei in fanweiList">
              {{fanwei.name}}<i :class="{'active':fanwei.hendler}"></i>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        titleList: [{name: '题型', id: 0, hendler: false}, {name: '范围', id: 3, hendler: false}],
        tixingList: [
          {name: '全部', id: 0, hendler: true},
          {name: '选择题', id: 1, hendler: false},
          {name: '填空题', id: 2, hendler: false},
          {name: '判断题', id: 3, hendler: false},
          {name: '连线题', id: 4, hendler: false},
          {name: '排序题', id: 5, hendler: false},
          {name: '断句题', id: 6, hendler: false},
          {name: '解答题', id: 7, hendler: false},
          {name: '阅读理解', id: 8, hendler: false},
        ],
        fanweiList: [{name: '全部', id: 0, hendler: true}, {name: '未发布过的试题', id: 1, hendler: false}],
        activeObj: {tixing: 0, fanwei: 0},
      }
    },
    components: {},
    methods: {
      switchTab(title) {
        if(title.hendler){
          title.hendler = false;
        }else{
          this.titleList.forEach(v => {
            v.hendler = false;
          });
          title.hendler = true;
        }
        this.titleList.splice(0, 1, this.titleList[0]);
      },
      switchTixing(tixing) {
        this.tixingList.forEach(v => {
          v.hendler = false;
        });
        tixing.hendler = true;
        this.activeObj.tixing = tixing.id;
        this.tixingList.splice(0, 1, this.tixingList[0]);
        this.titleList[0].hendler = false;
        this.$emit('child', this.activeObj);
      },
      switchFanwei(fanwei) {
        this.fanweiList.forEach(v => {
          v.hendler = false;
        });
        fanwei.hendler = true;
        this.activeObj.fanwei = fanwei.id;
        this.fanweiList.splice(0, 1, this.fanweiList[0]);
        this.titleList[1].hendler = false;
        this.$emit('child', this.activeObj);
      },
      hide() {
        this.titleList.forEach(v => {
          v.hendler = false;
        });
      }
    },
    created() {

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "./src/assets/scss/common/_mixin";

  .topic_switch {
    position: relative;
    .title {
      height: 96px/$ppr;
      background: #fff;
      border-bottom:1px/$ppr solid #E8E8E8;
      a {
        display: block;
        float: left;
        width: 50%;
				height:40px/$ppr;
				margin-top:28px/$ppr;
        text-align: center;
        font-size: 30px/$ppr;
        color: #333;
        box-sizing: border-box;
				-webkit-tap-highlight-color: transparent;
        &.topic_type {
          border-right: 1px/$ppr solid #dcdcdc;
        }
        i {
          display: inline-block;
          margin-left: 10px/$ppr;
          width: 25px/$ppr;
          height: 13px/$ppr;
          background: url("./img/icon_open.png") no-repeat;
          background-size: 100% 100%;
          vertical-align: middle;
        }
        &.active {
          color: #5e89ef;
          i {
            background: url("./img/icon_close.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    ul {
      position: absolute;
      padding: 24px/$ppr 24px/$ppr 32px/$ppr;
      background: #fff;
      z-index: 1;
      li {
        position: relative;
        float: left;
        margin-top: 60px/$ppr;
        padding-left: 66px/$ppr;
        width: 336px/$ppr;
        box-sizing: border-box;
        &:nth-child(1), &:nth-child(2) {
          margin-top: 0;
        }
        i {
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -20px/$ppr;
          width: 40px/$ppr;
          height: 40px/$ppr;
          background: url("./img/icon_unchecked.png") no-repeat;
          background-size: 100% 100%;
          &.active {
            background: url("./img/circle.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .mask{
      position: absolute;
      top: 96px/$ppr;
      left: 0;
      bottom: 0;
      width: 100vw;
      height: 100vh;
      border-top: 1px/$ppr solid #dcdcdc;
      background-color: $mask;
      transition: background-color .3s linear;
    }
  }
  .my-fade-enter,
  .my-fade-leave-to{
    background-color: rgba(0,0,0,0)!important;
  }
  .tixing,
  .fanwei{
    position: absolute;
    top: 97px/$ppr;
    width: 100%;
    height: 0;
    overflow: hidden;
    transition: all .3s linear;
  }
  .my-slide1-enter,
  .my-slide1-leave-to,
  .my-slide2-enter,
  .my-slide2-leave-to{
    height: 0 !important;
  }
</style>
